import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-wiki-tab',
  templateUrl: './wiki-tab.component.html',
  styleUrls: ['./wiki-tab.component.scss']
})
export class WikiTabComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
